import React, { useEffect, useState } from "react"
import { CheckoutDetailOrderList } from "./CheckoutDetailOrderList.tsx";
import { CheckoutDetailReservationList } from "./CheckoutDetailReservationList.tsx";
import { CheckoutDetailClosingsList } from "./CheckoutDetailClosingsList.tsx";
import { CheckoutDetailExtraOperationsList } from "./CheckoutDetailExtraOperationsList.tsx";
import { useParams, useNavigate, useLocation } from "react-router";

type TabType = 'orders' | 'reservations' | 'checkout-closings' | 'checkout-extra-operations'
export const CheckoutDetailTabs: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [selectedTab, setSelectedTab] = useState<TabType>('orders')

  const navigateToTab = (tab: TabType) => {
    navigate(`/checkout-detail/${tab}${location.search || ''}`)
  }

  useEffect(() => {
    if (params?.tab) {
      setSelectedTab(params.tab as TabType)
    }
  }, [params])

  return (
    <div className="h-body-without-header p-6 flex flex-col">
      <div className="scrollable-y bg-white border-b-1 border-solid border-border-light flex-1 rounded-md p-6">
        <div role="tablist" className="tabs border-b-1 border-solid border-border-light pb-6">
          <a role="tab" className={`btn btn-link text-black! mr-2 tab ${selectedTab === 'orders' ? 'tab-active btn-primary btn-soft text-primary!' : ''}`} onClick={() => navigateToTab('orders')}>
          Pokladní doklady
          </a>
          <a role="tab" className={`btn btn-link text-black! mr-2 tab ${selectedTab === 'reservations' ? 'tab-active btn-primary btn-soft text-primary!' : ''}`} onClick={() => navigateToTab('reservations')}>
            Rezervace
          </a>
          <a role="tab" className={`btn btn-link text-black! mr-2 tab ${selectedTab === 'checkout-closings' ? 'tab-active btn-primary btn-soft text-primary!' : ''}`} onClick={() => navigateToTab('checkout-closings')}>
            Uzávěrky
          </a>
          <a role="tab" className={`btn btn-link text-black! tab ${selectedTab === 'checkout-extra-operations' ? 'tab-active btn-primary btn-soft text-primary!' : ''}`} onClick={() => navigateToTab('checkout-extra-operations')}>
            Vyrovnávací operace
          </a>
        </div>
        <div className="pt-6">
          {selectedTab === 'orders' && <CheckoutDetailOrderList />}
          {selectedTab === 'reservations' && <CheckoutDetailReservationList />}
          {selectedTab === 'checkout-closings' && <CheckoutDetailClosingsList />}
          {selectedTab === 'checkout-extra-operations' && <CheckoutDetailExtraOperationsList />}
        </div>
      </div>
    </div>
  )
}
